/* eslint-disable no-unused-vars */
export const PAGE_PADDING = "30px";
export const CARD_GAP = "30px";
export const CARD_TITLE = "text-lg font-bold  self-start mb-5";
export const BORDER_RADIUS = "rounded-2xl";
export const COLORS = {
  PRIMARY: "#FFC000",
  PRIMARY_LIGHT: "#fbe49f",
  RED: "#F05A28",
  PURPLE: "#6C60FF",
  YELLOW: "#FFC000",
  BLACK: "#161616",
  BLACK_LIGHTER: "#7C878E",
  PHASE_A: "#a55935",
  PHASE_B: "#151616",
  PHASE_C: "#a0a1a1",
  NEUTRAL: "#1266aa",
  GREEN: "#2ecc71",
};
export enum ROLE {
	ADMIN = 'admin',
	MANAGER = 'manager',
	OPERATIONS = 'operation',
	FINANCE = 'finance',
	OTHER = 'other',
}

export const REFETCH_CONFIGURATION = {
  refetchInterval: 1000 * 60  * 1, // Set to 1minutes seconds (5000ms)
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  staleTime: 0, // Consider data immediately stale to encourage refreshes
};
export const ROWS_PER_PAGE = 10



